import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {DepartmentsActions} from '../store';
import {DepartmentsSelectors} from '../store/selectors';

@Injectable()
export class DepartmentsLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadDepartmentsDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadDepartmentsDone() {

    return this.store.pipe(
      select(DepartmentsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(DepartmentsActions.ReadDepartments());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
